const DynamicButtonValidations = (
  button,
  checkFieldsValidation,
  checkChangeCategoryValidation
) => {
  const checkInsideAppValidations = () => {
    const {
      pageLink,
      peopleLink,
      listLink,
      collectionLink,
      contentLink,
      videoLink,
      buttonPosition,
      linkText,
      markdownLabel,
    } = button;
    const linkValueAvailable =
      pageLink ||
      peopleLink ||
      listLink ||
      collectionLink ||
      contentLink ||
      videoLink;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop &&
        button.buttonPositionFromLeft &&
        linkText
      : linkText;
    return [linkValueAvailable, buttonTextAvailable];
  };

  const checkStoreLinksValidations = () => {
    const {
      appstoreLink,
      playstoreLink,
      linkText,
      buttonPosition,
      trackerLink,
      markdownLabel,
    } = button;
    const linkValueAvailable = (appstoreLink && playstoreLink) || trackerLink;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop &&
        button.buttonPositionFromLeft &&
        linkText
      : linkText;
    return [linkValueAvailable, buttonTextAvailable];
  };

  const checkSocialMediaValidations = () => {
    const {
      instagramLink,
      youtubeLink,
      twitterLink,
      facebookLink,
      linkText,
      buttonPosition,
      markdownLabel,
    } = button;
    const linkValueAvailable =
      instagramLink || youtubeLink || twitterLink || facebookLink;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop &&
        button.buttonPositionFromLeft &&
        linkText
      : linkText;
    return [linkValueAvailable, buttonTextAvailable];
  };

  const checkMusicValidations = () => {
    const {
      saavnLink,
      gaanaLink,
      linkText,
      buttonPosition,
      markdownLabel,
    } = button;
    const linkValueAvailable = saavnLink || gaanaLink;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop &&
        button.buttonPositionFromLeft &&
        linkText
      : linkText;
    return [linkValueAvailable, buttonTextAvailable];
  };
  const checkOtherValidations = () => {
    const { httpsLink, linkText, buttonPosition, markdownLabel } = button;
    const linkValueAvailable = httpsLink;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop &&
        button.buttonPositionFromLeft &&
        linkText
      : linkText;

    return [linkValueAvailable, buttonTextAvailable];
  };

  const checkValidationsDataAvailable = (
    linkValueAvailable,
    buttonTextAvailable
  ) => {
    var dataAvailable = linkValueAvailable && buttonTextAvailable;
    return !dataAvailable;
  };

  const checkValidations = () => {
    switch (button.category) {
      case "insideApp":
        var [
          linkValueAvailable,
          buttonTextAvailable,
        ] = checkInsideAppValidations();
        return checkValidationsDataAvailable(
          linkValueAvailable,
          buttonTextAvailable
        );
      case "storeLinks":
        var [
          linkValueAvailable,
          buttonTextAvailable,
        ] = checkStoreLinksValidations();
        return checkValidationsDataAvailable(
          linkValueAvailable,
          buttonTextAvailable
        );
      case "socialMedia":
        var [
          linkValueAvailable,
          buttonTextAvailable,
        ] = checkSocialMediaValidations();
        return checkValidationsDataAvailable(
          linkValueAvailable,
          buttonTextAvailable
        );
      case "music":
        var [linkValueAvailable, buttonTextAvailable] = checkMusicValidations();
        return checkValidationsDataAvailable(
          linkValueAvailable,
          buttonTextAvailable
        );
      case "other":
        var [linkValueAvailable, buttonTextAvailable] = checkOtherValidations();

        return checkValidationsDataAvailable(
          linkValueAvailable,
          buttonTextAvailable
        );
      default:
        return true;
    }
  };

  const checkChangeCategoryDataAvailable = (linkValueAvailable) => {
    const { buttonPosition, linkText, markdownLabel } = button;
    var customButtonValidations =
      button.buttonPositionFromTop || button.buttonPositionFromLeft;
    const buttonTextAvailable = markdownLabel
      ? true
      : buttonPosition == "custom"
      ? button.buttonPositionFromTop ||
        button.buttonPositionFromLeft ||
        linkText
      : linkText != "Watch On";
    var dataAvailable =
      linkValueAvailable || buttonTextAvailable || customButtonValidations;
    return dataAvailable;
  };

  const changeCategoryValidations = () => {
    switch (button.category) {
      case "insideApp":
        var [linkValueAvailable] = checkInsideAppValidations();
        return checkChangeCategoryDataAvailable(linkValueAvailable);
      case "storeLinks":
        var [linkValueAvailable] = checkStoreLinksValidations();
        return checkChangeCategoryDataAvailable(linkValueAvailable);
      case "socialMedia":
        var [linkValueAvailable] = checkSocialMediaValidations();
        return checkChangeCategoryDataAvailable(linkValueAvailable);
      case "music":
        var [linkValueAvailable] = checkMusicValidations();
        return checkChangeCategoryDataAvailable(linkValueAvailable);
      case "other":
        var [linkValueAvailable] = checkOtherValidations();
        return checkChangeCategoryDataAvailable(linkValueAvailable);
      default:
        return false;
    }
  };
  if (checkFieldsValidation) {
    return checkValidations();
  } else if (checkChangeCategoryValidation) {
    return changeCategoryValidations();
  }
};
export default DynamicButtonValidations;
